"use client";
import React, { useEffect, useState } from "react";
import "./text.css"; // Make sure your CSS file is correctly linked
import { cn } from "../lib/utils.js"; // Adjust the path if necessary

const TextGenerateEffect = ({ text, className }) => {
  const [wordsArray, setWordsArray] = useState([]);
  const [showWords, setShowWords] = useState(false);

  useEffect(() => {
    // Split the text into words and set the state
    setWordsArray(text.split(" "));

    // Start the animation after 2 seconds
    const timer = setTimeout(() => {
      setShowWords(true);
    }, 2000); // Delay of 2 seconds

    // Clean up the timer
    return () => clearTimeout(timer);
  }, [text]);

  return (
    <div className={cn("font-bold", className)}>
      <div className="my-4">
        <div className="dark:text-white text-black leading-snug tracking-wide">
          {wordsArray.map((word, idx) => (
            <span
              key={word + idx}
              className={`fade-in ${showWords ? 'visible' : ''}`} // CSS class for fade-in effect
              style={{ transitionDelay: `${idx * 300}ms` }} // Delay for staggered effect
            >
              {word}{" "}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TextGenerateEffect;
